/**
 * ResumeMetric - LinkedIn Character Counter
 * Tracks character limits for LinkedIn fields.
 * @module tools/linkedinCounter
 */

export const LINKEDIN_LIMITS = {
    headline: { max: 220, label: 'Headline', searchTruncate: 120 },
    summary: { max: 2600, label: 'About / Summary', searchTruncate: 300 },
    title: { max: 100, label: 'Job Title' },
    company: { max: 100, label: 'Company Name' },
    post: { max: 3000, label: 'Post / Article Intro' },
    connection: { max: 300, label: 'Connection Request Note' },
    recommendation: { max: 3000, label: 'Recommendation' }
};

export function analyzeField(text, fieldKey) {
    const field = LINKEDIN_LIMITS[fieldKey];
    if (!field) return null;

    const length = (text || '').length;
    const remaining = field.max - length;
    const isOver = remaining < 0;
    const percentage = Math.min((length / field.max) * 100, 100);

    let truncatedPreview = null;
    if (field.searchTruncate && length > field.searchTruncate) {
        truncatedPreview = text.substring(0, field.searchTruncate) + '...';
    }

    return {
        field: field.label,
        maxLength: field.max,
        currentLength: length,
        remaining: Math.abs(remaining),
        isOver,
        percentage,
        truncatedPreview,
        searchTruncateAt: field.searchTruncate || null
    };
}
